<template>
  <div class="num-range__box">
    <el-input-number v-model="min" :controls="false" @change="handleChange" :min="$attrs.min" :max="$attrs.max"
      v-bind="$attrs"></el-input-number>
    -
    <el-input-number v-model="max" :controls="false" @change="handleChange" :min="$attrs.min" :max="$attrs.max"
      v-bind="$attrs"></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'yblEntiretyRang',
  model: {
    prop: 'val',
    event: 'change'
  },
  props: {
    val: {
      type: Array | String,
      default: () => ['', '']
    },
    compare: { // 比较大小
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      min: '',
      max: ''
    }
  },
  created () {
    let temp = Array.isArray(this.val) ? this.val : (this.val && this.val.split(','))
    temp = temp || []
    this.min = (temp.length > 0 && temp[0]) || ''
    this.max = (temp.length > 1 && temp[1]) || ''
  },
  methods: {
    handleChange (value) {
      // console.log(value)
      // console.log(this.min, this.max)
      if ((this.max < this.min) && this.compare) {
        this.max = this.min
      }
      this.$emit('change', [this.min, this.max])
    }
  },
  watch: {
    'val': function (newVal, oldVal) {
      if (this.val && this.val.length) {
        const val = Array.isArray(this.val) ? this.val : this.val.split(',')
        this.min = val[0]
        this.max = val[1]
      } else {
        this.min = ''
        this.max = ''
      }
    }
  }
}
</script>

<style lang="less">
@import url("../assets/less/color.less");
.num-range__box {
  width: 280px;
  border: 1px solid #dde0e6;
  border-radius: 2px;
  height: 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  .el-input-number--small {
    width: 130px;
    .el-input {
      min-width: 130px;
      width: 130px;
    }
    .el-input__inner {
      padding-left: 30px;
      padding-right: 30px;
      border: none;
      height: 29px;
      line-height: 29px;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/entiretyRang.vue